import { CSSProperties } from 'react';

import theme from '../../../assets/theme';
import useAccessBadge from '../../../hooks/useAccessBadge';
import Profile from '../../_atoms/_Profile';

const SmartProfile = ({
  style,
  radius,
  onClick,
  onImageLoaded,
  backgroundColor,
}: {
  style?: CSSProperties;
  radius?: number;
  onClick?: () => void;
  onImageLoaded?: () => void;
  backgroundColor?: string;
}) => {
  const { accessBadge: userAccessBadge } = useAccessBadge();

  const userName = userAccessBadge?.user.firstName || userAccessBadge?.user.email;

  return (
    <Profile
      radius={radius}
      style={style}
      onClick={onClick}
      firstLetter={userName ? userName.substring(0, 1) : undefined}
      onImageLoaded={onImageLoaded}
      backgroundColor={backgroundColor}
      fallbackLogoConfig={{
        color: theme.colors.orange,
        logo: ':curipod_normal:',
      }}
    />
  );
};

export default SmartProfile;
